unit NetItemType;
{

/* Initial. */

}
interface

uses
  TemperatureType, WeightScaleType;

type
  TNetItemType = class
  private
    fNetKey: String;
    fName: String;
    fAmountActive: Word;
    fAmountNotActive: Word;
    fWeightScale: TWeightScaleType;
    fTemperature: TTemperatureType;
    fCreationDate: String;
    fChangedDate: String;
    fActive: Boolean;
  public
    property NetKey: String read fNetKey;
    property Name: String read fName;
    property AmountActive: Word read fAmountActive;
    property AmountNotActive: Word read fAmountNotActive;
    property WeightScale: TWeightScaleType read fWeightScale;
    property Temperature: TTemperatureType read fTemperature;
    property CreationDate: String read fCreationDate;
    property ChangedDate: String read fChangedDate;
    property Active: Boolean read fActive;
  end;

implementation

end.
